import { tablet_ordering_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering.jpeg`,
      title: 'Restaurant Tablet Ordering',
      description: `Chowbus tablet ordering provides the ultimate ordering solution to elevate your diner and waitstaff's experience.`,
      youtubeVideoId: tablet_ordering_video_id.en,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering.jpeg`,
      title: 'iPad点餐系统，顾客自助点餐，设备限时免费 | 平板点餐',
      description: '强大的智能点餐设备，有效提升顾客点餐体验和餐厅运营效率',
      youtubeVideoId: tablet_ordering_video_id.zh,
    },
  },
  advances: {
    en: {
      title: `Restaurant Tablet Ordering = More Speed, More Sales`,
      subTitle: `One-stop ordering and payment solution to help grow your business with efficiency and convenience`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_1.png`,
          imageAlt: 'Contactless Ordering Experience',
          title: 'Contactless Ordering Experience',
          description:
            'Designed to empower your guests and your staff with an effective and efficient contactless ordering experience.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_2.png`,
          imageAlt: 'Reducing Labor Cost and Time',
          title: 'Reducing Labor Cost and Time',
          description:
            'Freeing your staff time to handle other value-added tasks, engage with guests, and build rapport, which creates a more fulfilling dining experience for both guests and staff.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_3.png`,
          imageAlt: 'Collect Valuable Guest Data',
          title: 'Collect Valuable Guest Data',
          description:
            'Providing a customer loyalty program to get a better rate of returning customers. Collect guest data on each transaction that can be leveraged to power your marketing and loyalty programs.',
        },
      ],
    },
    zh: {
      // title: `Chowbus 平板点餐，集成了一站式订餐和支付系统，帮助您的餐厅提升工作效率，节约人力成本，升级顾客体验`,
      // subTitle: ``,
      title: `更快的点餐速度，更高的营业额`,
      subTitle: `iPad点餐系统的自助点餐体验以及大屏吸睛图片帮助您有效提升客单价和翻桌率，并优化点餐体验`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_1.png`,
          imageAlt: '无接触的点餐体验',
          title: '无接触的点餐体验',
          description: `顾客可以根据菜品图片、描述等自助下单，
          还可以随时加菜，提升点单的自由度`,
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_2.png`,
          imageAlt: '合理的时间分配',
          title: '合理的时间分配',
          description: `相比于低效地等待顾客点单，
          店员可以将时间投入到更有价值的服务上`,
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_feature_3.png`,
          imageAlt: '有效的产品组合',
          title: '有效的产品组合',
          description: `平板点餐+会员系统，可以有效提升会员数和复购率；
          平板点餐+手持POS，可以有效提升点单、支付效率`,
        },
      ],
    },
  },

  features: {
    en: {
      title: 'Upgrade Your Restaurant',
      desc: 'Chowbus is committed to provide the ultimate diner-driven experience, increase operational efficiency, and improve your restaurant margins.',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'Upgrade Guest Dining Experiences',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_1.png`,
          items: [
            {
              desc: `Dish photos look great on big screens! This is a convenient alternative for guests who don’t use smartphones.`,
            },
            {
              desc: `Allow customers to browse your restaurant's dish pictures more vividly.`,
            },
            // { desc: 'Bilingual System: Maximum coverage, all users can enjoy ordering experience.' },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'More Profit with More Efficiency',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_2.png`,
          items: [
            {
              desc: 'Orders placed on the tablet will be sent to the kitchen directly through our All-in-one POS system. Skip manual inputs from your servers!',
            },
            {
              desc: 'Simplify the waiter workflow! Our average restaurant owner improved their table turnover rate by 25% and saved $8,000/mo on labor costs.',
            },
            { desc: 'Save on print expenses with cloud-based edits to your menu items, pictures, and prices.' },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: 'Bigger Orders & More Frequent Visitors',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_3.png`,
          items: [
            {
              desc: 'Multiple diners can order through your tablet at the same time. Guests can add dishes to their order whenever they want.',
            },
            {
              desc: 'Enable loyalty programs, coupons, or cash-back rewards for your visitors!',
            },
          ],
        },
      ],
    },
    zh: {
      title: '升级您的餐厅体验',
      desc: 'Chowbus iPad点餐系统专为餐厅定制，能全面升级您的餐厅，大幅提升运营效率及利润率',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '更好的点餐体验',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_1.png`,
          items: [
            {
              desc: ' 顾客使用平板自助浏览菜单并下单，无需等待店员，还可更快地享受美食',
            },
            { desc: `清晰的菜品图在平板上会显得更加诱人，有效帮助顾客了解菜品并吸引顾客下单` },
            { desc: `双语点餐界面能让中文母语者倍感亲切的同时，满足更多食客的点餐诉求` },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '更快的运营效率',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_2.png`,
          items: [
            {
              desc: '平板下单的订单会自动发送至后厨，减少传递菜品信息的人力和时间成本',
            },
            {
              desc: '平板点单精简店员的服务流程，有效减少月均$8,000的人力成本的同时，提升25%的翻台率',
            },
            { desc: '在云端更新电子菜单，即可同步到平板等所有POS设备上，节省纸质印刷费用' },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '更高的餐厅收入',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_tablet_ordering_advance_3.png`,
          items: [
            {
              desc: '支持多人同时点餐，顾客下单后还可随时加菜，大幅提升客单价',
            },
            {
              desc: '利用平板点餐✖️会员系统，顾客可以注册会员、积累积分并兑换菜品，有效提升顾客黏性',
            },
          ],
        },
      ],
    },
  },
  whyNotChooseChowBus: {
    en: {
      title: 'Why Restaurants Choose Chowbus',
    },
    zh: {
      title: '他们选择Chowbus iPad点餐系统的原因',
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-kajiken.jpeg`,
      productLine: 'Tablet Ordering',
      desc: {
        zh: `KAJIKEN拉面非常注重顾客的用餐体验，因此当他们了解到Chowbus POS的平板点餐功能，可以提供一站式的订餐和支付系统后，马上选择使用平板点餐。不但帮助餐厅提升了工作效率，节约了人力成本，更重要的是升级了顾客的点餐、用餐体验。`,
        en: `KAJIKEN puts customer experience above all else. When they had the opportunity to improve line speed, tipping, and ordering experience with a modern restaurant point of sale, they jumped on it.`,
      },
      restaurantName: { zh: `KAJIKEN`, en: `KAJIKEN` },
      location: { zh: '巴尔的摩', en: 'Baltimore' },
      link: '/business-types/sushi-ramen/kajiken',
    },
  ],
};

export default SectionContent;
